<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        updateUrl() {
            const currentDate = this.$store.getters.getCurrentDate;
            const currentFacility = this.$store.getters.getCurrentFacility;
            let query = { date: currentDate }
            if(currentFacility !== null) {
                query.facility = currentFacility.value
            }
            
            if (this.$route.path === '/facilities') {
                this.$router.push({ path: '/day', query });
            } else {
                this.$router.push({ query });
            }
        }
    },
    watch: {
        '$store.getters.getCurrentDate': {
            handler: 'updateUrl',
            immediate: true,
        },
        '$store.getters.getCurrentFacility': {
            handler: 'updateUrl',
            immediate: true,
        },
    },
}
</script>

<style scoped>
/* Your styles here */
</style>